export default __webpack_public_path__ + "static/media/product-cup.95b0eed1.svg";